"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReviewDecisionButtonsState = void 0;
const reviewDecisionStatus_1 = require("evolution-common/lib/services/reviews/reviewDecisionStatus");
/**
 * Derives the state of the review buttons of one survey object from its aggregated status.
 * Shared by the buttons of the object boxes and the interview links of the top menu, which
 * show the same decisions in two different visual styles.
 * @param status - Aggregated review status for the object, undefined when never reviewed
 * @returns Which buttons to show and which of them are pressed
 */
const getReviewDecisionButtonsState = (status) => {
    var _a, _b;
    const currentDecision = status === null || status === void 0 ? void 0 : status.currentUserDecision;
    const forceApprovePressed = (status === null || status === void 0 ? void 0 : status.currentUserForceApproved) === true;
    // Number of reviewers other than the current user who already decided on this object.
    // approvalCount/rejectionCount exclude force-approved rows, so the current user's own
    // decision is counted in them only when it exists and is not force-approved.
    const reviewerCount = ((_a = status === null || status === void 0 ? void 0 : status.approvalCount) !== null && _a !== void 0 ? _a : 0) + ((_b = status === null || status === void 0 ? void 0 : status.rejectionCount) !== null && _b !== void 0 ? _b : 0);
    const currentUserCountedInReviewerTotals = currentDecision !== undefined && !forceApprovePressed;
    const otherReviewersCount = reviewerCount - (currentUserCountedInReviewerTotals ? 1 : 0);
    return {
        rejectPressed: currentDecision === 'reject',
        approvePressed: currentDecision === 'approve',
        forceApprovePressed,
        showConflictWarning: (status === null || status === void 0 ? void 0 : status.effectiveStatus) === 'conflict',
        canClearDecision: !forceApprovePressed,
        showForceApprove: status !== undefined && ((0, reviewDecisionStatus_1.blocksApproval)(status.effectiveStatus) || status.isForceApproved === true),
        showRequestReReview: otherReviewersCount > 0,
        // Pressed state reflects only the current user's own re-review request, not other reviewers'.
        reReviewPressed: (status === null || status === void 0 ? void 0 : status.reReviewRequestedByCurrentUser) === true,
        askedToReReview: (status === null || status === void 0 ? void 0 : status.reReviewRequestedOfCurrentUser) === true
    };
};
exports.getReviewDecisionButtonsState = getReviewDecisionButtonsState;
//# sourceMappingURL=reviewDecisionButtonsState.js.map